import { Button } from '@/components/ui/button';
import {
    DataTable,
    DataTableBody,
    DataTableCell,
    DataTableHead,
    DataTableHeader,
    DataTableHeaderRow,
    DataTableRow,
    EmptyState,
} from '@/components/system';
import type { PatientReportOverview } from '@/types/patient-overview';
import type { ReactNode } from 'react';
import { formatDateTime } from './formatters';
import { ReportStatusBadge } from './StatusBadges';

type Props = {
    reports: PatientReportOverview[];
    onOpenReport: (reportId: string) => void;
    emptyAction?: ReactNode;
};

export default function PatientReportsTable({ reports, onOpenReport, emptyAction }: Props) {
    if (reports.length === 0) {
        return (
            <EmptyState
                title="Nenhum laudo associado"
                description="Ainda não existem laudos vinculados a este paciente."
                action={emptyAction}
            />
        );
    }

    return (
        <DataTable>
            <DataTableHeader>
                <DataTableHeaderRow>
                    <DataTableHead>Status</DataTableHead>
                    <DataTableHead>Criado em</DataTableHead>
                    <DataTableHead>Atualizado em</DataTableHead>
                    <DataTableHead>Ações</DataTableHead>
                </DataTableHeaderRow>
            </DataTableHeader>
            <DataTableBody>
                {reports.map((report) => (
                    <DataTableRow key={report.id}>
                        <DataTableCell>
                            <ReportStatusBadge status={report.status} />
                        </DataTableCell>
                        <DataTableCell variant="subtle">
                            {formatDateTime(report.created_at)}
                        </DataTableCell>
                        <DataTableCell variant="subtle">
                            {formatDateTime(report.updated_at)}
                        </DataTableCell>
                        <DataTableCell>
                            <Button
                                variant="surface"
                                size="sm"
                                onClick={() => onOpenReport(report.id)}
                            >
                                Abrir laudo
                            </Button>
                        </DataTableCell>
                    </DataTableRow>
                ))}
            </DataTableBody>
        </DataTable>
    );
}
